import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { paymentsAPI } from './api';

/** Stripe Checkout: in the app it opens in the in-app browser, on the web in the same tab. */
export async function openCheckout(url) {
  if (Capacitor.isNativePlatform()) {
    await Browser.open({ url });
  } else {
    window.location.href = url;
  }
}

/**
 * Initiate payment for a booking using Stripe Checkout Sessions.
 * Creates a Checkout Session on the backend, then redirects to Stripe-hosted payment page.
 * @param {string} bookingId - The booking ID to pay for
 * @returns {Promise<{success: boolean, error?: string}>}
 */
export async function payBooking(bookingId) {
  try {
    // 1. Create Checkout Session on backend (pass origin for redirect URLs)
    const res = await paymentsAPI.createPayment(bookingId, {
      origin: window.location.origin,
    });
    const { checkout_url } = res.data;

    if (!checkout_url) {
      return { success: false, error: 'URL di pagamento non disponibile' };
    }

    // 2. Redirect to Stripe-hosted checkout page
    window.location.href = checkout_url;

    // This line won't execute as the browser redirects
    return { success: true };
  } catch (err) {
    return {
      success: false,
      error: err.response?.data?.detail || 'Errore nel pagamento',
    };
  }
}
